import { render, staticRenderFns } from "./c-tab@.vue?vue&type=template&id=aeaa77e2&"
import script from "./c-tab@.vue?vue&type=script&lang=ts&"
export * from "./c-tab@.vue?vue&type=script&lang=ts&"
import style0 from "./c-tab@.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports